<template lang="html">
  <section class="login row-center ais">
    <div class="left row-center">
      <h1 class="logo">
        <img src="/static/img/logo-pye-ufv.png" alt="Logo" />
      </h1>
    </div>

    <div class="right row-center" :how="how">
      <div class="contenedor-formulario">
        <!-- <h1 class="main-title">Portal temporalmente sin servicio</h1> -->
        <!-- <h2>
          Estaremos en labores de mantenimiento hasta el próximo lunes 11 de
          noviembre, para cualquier duda puede contactar en
          <u
            ><a href="mailto:c.profesionales@ufv.es"
              >c.profesionales@ufv.es</a
            ></u
          >
          <br />Rogamos disculpe las molestias.
        </h2> -->
        <formulario  @setRecordar="setRecordar"></formulario>
      </div>
    </div>

    <popup-recordar
      v-if="!!showrecordar"
      :type="showrecordar"
      @close="showrecordar = false"
    ></popup-recordar>
  </section>
</template>

<script lang="js">

import formulario from '@/components/view-parts/login/formulario';
import popuprecordar from '@/components/view-parts/login/popup-recuperacion-pass';

export default {
  name: 'login',

  data() {
    return {
      how: '',
      showrecordar : ''
    }
  },
  methods: {
    setform(value) {
      this.how = value;
      this.$route.params.id = value;
      window.history.pushState('Login', 'Login', `/login/${value}`);
    },
    setRecordar(value){
      this.showrecordar = value;
    }
  },
  components : {
    'formulario' : formulario,
    'popup-recordar' : popuprecordar
  }
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/views/login.vue